import { FC, lazy, memo, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { getQueryValue } from '@netiva/classifieds-common';
import { Loader } from '@netiva/classifieds-ui';

import { routes } from '@/lib/routes';
import { Tutorial } from './components';

// Redoc is large and only needed on the docs tab
const ApiDocs = lazy(() => import('./components/ApiDocs').then((module) => ({ default: module.ApiDocs })));

const tabs = ['tutorial', 'docs'] as const;

export const ApiDocsPage: FC = memo(function ApiPage() {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const tab = getQueryValue(params.tab, 'tutorial') as 'docs' | 'tutorial';

  const handleTabChange = (index: number) => {
    navigate(routes.apiDocs(tabs[index]));
  };

  return (
    <Tabs isLazy size="lg" index={tabs.indexOf(tab)} onChange={handleTabChange}>
      <TabList>
        <Tab>{t('api.tabs.tutorial')}</Tab>
        <Tab>{t('api.tabs.apiDocs')}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Tutorial />
        </TabPanel>
        <TabPanel>
          <Suspense fallback={<Loader isLoading />}>
            <ApiDocs />
          </Suspense>
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
});
